/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  ----------------------------------------------------------------------------------------
  Item Name: Virtual Job Experience
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store/store.js';
import studentRoutes from '@/router/studentRoutes';
import teacherRoutes from '@/router/teacherRoutes';
import fullpageRoutes from '@/router/fullpageRoutes';
import { setPageTitleFromRoute } from '@/utils/pageTitle';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: '',
      component: () => import('@/views/pages/Home.vue'),
      meta: { title: 'Home' },
    },
    studentRoutes,
    teacherRoutes,
    fullpageRoutes,
    // Redirect to 404 page, if no match found
    {
      path: '*',
      component: () => import('@/views/pages/Error404.vue'),
      meta: { title: 'Page Not Found' },
    },
  ],
});

router.beforeEach(function (to, from, next) {
  if (to.meta.requiresAuth === 'student' && !store.getters['authStudent/isLoggedIn']) {
    next('/');
  } else if (to.meta.redirectIfAuth === 'student' && store.getters['authStudent/isLoggedIn']) {
    next('/student/dashboard');
  } else {
    next();
  }

  if (to.meta.requiresAuth === 'teacher' && !store.getters['authTeacher/isLoggedIn']) {
    next('/');
  } else if (to.meta.redirectIfAuth === 'teacher' && store.getters['authTeacher/isLoggedIn']) {
    next('/teacher/dashboard');
  } else {
    next();
  }
});

router.afterEach((to) => {
  // Give each route a descriptive document title (WCAG SC 2.4.2). Views that render named
  // content can refine this afterwards via setPageTitle().
  setPageTitleFromRoute(to);

  // Remove initial loading
  const appLoading = document.getElementById('loading-bg');
  if (appLoading) {
    appLoading.style.display = 'none';
  }
});

export default router;
